// extracted by mini-css-extract-plugin
export var actions = "_ia-d";
export var benefitCard = "_ia-a";
export var benefitIcon = "_ia-b";
export var benefitLabel = "_ia-c";
export var benefits = "_ia-9";
export var bodyText = "_ia-8";
export var closeButton = "_ia-2";
export var content = "_ia-3";
export var eyebrow = "_ia-4";
export var heading = "_ia-5";
export var image = "_ia-f";
export var imagePanel = "_ia-e";
export var modal = "_ia-0";
export var shell = "_ia-1";
export var title = "_ia-6";
export var titleOffer = "_ia-7";